"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.listGroupItem = void 0;

var _colors = require("./colors");

var _utils = require("./utils");

var listGroupItem = {
  colors: {
    primary: {
      colorDisabled: _colors.colors.gray,
      backgroundColorDisabled: _colors.colors.white,
      colorActive: _colors.colors.white,
      color: _colors.colors.blueAlertText,
      backgroundColor: _colors.colors.blueAlertBorder,
      backgroundColorHoverFocusAction: _colors.colors.blueAlertBorderTop,
      backgroundColorActive: _colors.colors.blueAlertText,
      backgroundColorHoverFocusActive: _colors.colors.blueAlertText,
      borderColorActive: _colors.colors.blueAlertText,
      borderColor: _colors.colors.borderCard
    },
    secondary: {
      colorDisabled: _colors.colors.gray,
      backgroundColorDisabled: _colors.colors.white,
      colorActive: _colors.colors.white,
      color: _colors.colors.grayAlertText,
      backgroundColor: _colors.colors.grayAlertBorder,
      backgroundColorHoverFocusAction: _colors.colors.grayAlertBorderTop,
      backgroundColorActive: _colors.colors.grayAlertText,
      backgroundColorHoverFocusActive: _colors.colors.grayAlertText,
      borderColorActive: _colors.colors.grayAlertText,
      borderColor: _colors.colors.borderCard
    },
    success: {
      colorDisabled: _colors.colors.gray,
      backgroundColorDisabled: _colors.colors.white,
      colorActive: _colors.colors.white,
      color: _colors.colors.greenAlertText,
      backgroundColor: _colors.colors.greenAlertBorder,
      backgroundColorHoverFocusAction: _colors.colors.greenAlertBorderTop,
      backgroundColorActive: _colors.colors.greenAlertText,
      backgroundColorHoverFocusActive: _colors.colors.greenAlertText,
      borderColorActive: _colors.colors.greenAlertText,
      borderColor: _colors.colors.borderCard
    },
    info: {
      colorDisabled: _colors.colors.gray,
      backgroundColorDisabled: _colors.colors.white,
      colorActive: _colors.colors.white,
      color: _colors.colors.cyanAlertText,
      backgroundColor: _colors.colors.cyanAlertBorder,
      backgroundColorHoverFocusAction: _colors.colors.cyanAlertBorderTop,
      backgroundColorActive: _colors.colors.cyanAlertText,
      backgroundColorHoverFocusActive: _colors.colors.cyanAlertText,
      borderColorActive: _colors.colors.cyanAlertText,
      borderColor: _colors.colors.borderCard
    },
    warning: {
      colorDisabled: _colors.colors.gray,
      backgroundColorDisabled: _colors.colors.white,
      colorActive: _colors.colors.white,
      color: _colors.colors.yellowAlertText,
      backgroundColor: _colors.colors.yellowAlertBorder,
      backgroundColorHoverFocusAction: _colors.colors.yellowAlertBorderTop,
      backgroundColorActive: _colors.colors.yellowAlertText,
      backgroundColorHoverFocusActive: _colors.colors.yellowAlertText,
      borderColorActive: _colors.colors.yellowAlertText,
      borderColor: _colors.colors.borderCard
    },
    danger: {
      colorDisabled: _colors.colors.gray,
      backgroundColorDisabled: _colors.colors.white,
      colorActive: _colors.colors.white,
      color: _colors.colors.redAlertText,
      backgroundColor: _colors.colors.redAlertBorder,
      backgroundColorHoverFocusAction: _colors.colors.redAlertBorderTop,
      backgroundColorActive: _colors.colors.redAlertText,
      backgroundColorHoverFocusActive: _colors.colors.redAlertText,
      borderColorActive: _colors.colors.redAlertText,
      borderColor: _colors.colors.borderCard
    },
    light: {
      colorDisabled: _colors.colors.gray,
      backgroundColorDisabled: _colors.colors.white,
      colorActive: _colors.colors.white,
      color: _colors.colors.gray100AlertText,
      backgroundColor: _colors.colors.gray100AlertBorder,
      backgroundColorHoverFocusAction: _colors.colors.gray100AlertBorderTop,
      backgroundColorActive: _colors.colors.gray100AlertText,
      backgroundColorHoverFocusActive: _colors.colors.gray100AlertText,
      borderColorActive: _colors.colors.gray100AlertText,
      borderColor: _colors.colors.borderCard
    },
    dark: {
      colorDisabled: _colors.colors.gray,
      backgroundColorDisabled: _colors.colors.white,
      colorActive: _colors.colors.white,
      color: _colors.colors.gray800AlertText,
      backgroundColor: _colors.colors.gray800AlertBorder,
      backgroundColorHoverFocusAction: _colors.colors.gray800AlertBorderTop,
      backgroundColorActive: _colors.colors.gray800AlertText,
      backgroundColorHoverFocusActive: _colors.colors.gray800AlertText,
      borderColorActive: _colors.colors.gray800AlertText,
      borderColor: _colors.colors.borderCard
    },
    default: {
      colorDisabled: _colors.colors.gray,
      backgroundColor: _colors.colors.white,
      backgroundColorDisabled: _colors.colors.white,
      backgroundColorAction: _colors.colors.gray100,
      backgroundColorHoverFocusAction: _colors.colors.gray100,
      color: _colors.colors.gray700,
      colorActive: _colors.colors.white,
      colorAction: _colors.colors.gray700,
      borderColor: _colors.colors.borderCard,
      borderColorActive: _colors.colors.blue,
      backgroundColorActive: _colors.colors.blue
    }
  },
  padding: {
    default: '0.75rem 1.25rem'
  },
  border: _utils.utils.border,
  borderRadius: _utils.utils.borderRadius
};
exports.listGroupItem = listGroupItem;